import Icon from "components/ui/Icon";
import UILabel from "components/ui/UILabel";
import { Link as RouterLink } from "react-router-dom";
import { getDashboard } from "store/api/apiSlice";
import styled from "styled-components";
import { formatCurrency } from "utils/string";

const Button = styled(RouterLink)`
  display: flex;
  justify-content: space-between;
  padding: 16px;
  width: 100%;

  border-radius: ${(props) => props.theme.borderRadius.micro}px;
  background-color: ${(props) => props.theme.colors.tertiary}33;
  color: ${(props) => props.theme.colors.primary};

  text-align: left;
  text-decoration: none;
`;

const PaydayCta = () => {
  const { data: dashboard } = getDashboard();

  return (
    <Button to="/payday" viewTransition>
      <UILabel.Medium>
        You have ${formatCurrency(dashboard?.outstandingEwaTransactions)}{" "}
        scheduled for payday
      </UILabel.Medium>

      <Icon name="chevronRight" color="primary" />
    </Button>
  );
};

export default PaydayCta;
